import { SxProps, Theme } from '@mui/material';
import Box from '@mui/material/Box';

import { OverflowAwareText } from '~components/Order/ordersDispatchStyledComponents';
import { FileAttachment } from '~hooks/useFileAttachment/models';

interface UploadDateColumnProps {
  file: FileAttachment;
  sx?: SxProps<Theme>;
}

export default function UploadDateColumn({ file, sx }: UploadDateColumnProps) {
  const { updatedAt } = file;

  return (
    <Box sx={{ ...sx, overflow: 'hidden' }}>
      <OverflowAwareText>{updatedAt.format('MMM DD, YYYY')}</OverflowAwareText>
    </Box>
  );
}
